import type { DayWorkStatusKind } from "../types/dashboard2-work-status.types";

export type Dashboard2WelcomePoolKind =
  | "office"
  | "mobile_working"
  | "unplanned"
  | "public_holiday";

export const DASHBOARD2_WELCOME_MESSAGE_KEYS: Record<Dashboard2WelcomePoolKind, readonly string[]> =
  {
    office: [
      "_dashboard2_welcome_office_1",
      "_dashboard2_welcome_office_2",
      "_dashboard2_welcome_office_3"
    ],
    mobile_working: [
      "_dashboard2_welcome_mobile_1",
      "_dashboard2_welcome_mobile_2",
      "_dashboard2_welcome_mobile_3"
    ],
    unplanned: [
      "_dashboard2_welcome_unplanned_1",
      "_dashboard2_welcome_unplanned_2",
      "_dashboard2_welcome_unplanned_3"
    ],
    public_holiday: [
      "_dashboard2_welcome_holiday_1",
      "_dashboard2_welcome_holiday_2",
      "_dashboard2_welcome_holiday_3"
    ]
  };

export const welcomePoolKindForStatus = (kind: DayWorkStatusKind): Dashboard2WelcomePoolKind => {
  if (kind === "office") {
    return "office";
  }

  if (kind === "mobile_working") {
    return "mobile_working";
  }

  if (kind === "public_holiday") {
    return "public_holiday";
  }

  return "unplanned";
};
